import { Fragment, useState, useEffect } from 'react';
import { Pagination } from 'antd';
import { Dashboard } from '../../../components/ExportImgFigma';
import '../styles.scss';
import { EyeOutlined, SettingOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import 'dayjs/locale/vi';
import { formatNumber } from '../../../services/mixin';
import MegaTable from '../../../components/MagaTableV2';
import { SHOW_KEYNAME } from '../../../env';

const Overview = ({ stData = {} as any, stChange = (data: any) => { } }) => {
  const { id } = useParams();
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.contact_person?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheContactPerson',
    col: [
      {
        headerName: 'Hành động',
        field: 'action',
        width: 100,
        resizable: false,
        sortable: false,
        filter: false,
        lockPosition: 'left',
        cellRenderer: (params: any) => {
          return (
            <div className='d-flex gap-4 justify-start align-center  h-full'>
              <EyeOutlined
                onClick={() => {
                  window.location.href = `/customer/pooling-data/customer-list/detail?id_sync=${params.data.cus_id}`;
                }}
                className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer}`}
              />
            </div>
          )
        },
      },
      ...tableColumns(stData.sourceColumnWarehouse),
      // {
      //   headerName: 'Mã định danh khách hàng',
      //   field: 'cus_crm',
      // },
      // {
      //   headerName: 'Loại khách hàng',
      //   field: 'cus_type_name',
      // },
      // {
      //   headerName: 'Tên Khách hàng/ Tổ chức',
      //   field: 'cus_name',
      // },
      // {
      //   headerName: 'Giới tính',
      //   field: 'cus_gender_name',
      // },
      // {
      //   headerName: 'CCCD/ Hộ chiếu',
      //   field: 'cus_dms_id_card_no',
      // },
      // {
      //   headerName: 'Mã số thuế',
      //   field: 'cus_id_tax',
      // },
      // {
      //   headerName: 'Số điện thoại',
      //   field: 'cus_tel',
      // },
      // {
      //   headerName: 'Email',
      //   field: 'cus_email'
      // },
      // {
      //   headerName: 'Ngành nghề',
      //   field: 'cus_career_name',
      // },
    ],
    listData: [],
  });

  return (
    <Fragment>
      <div className='custom-page-css w-full py-3 flex flex-column gap-3'>
        <div className="custom-page-css w-full flex gap-3">
          <div className="custom-page-css  flex flex-1 flex-column rounded border">
            <div className="custom-page-css w-full flex items-center justify-center gap-4 p-3 border-b">
              <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
              </div>
              <span className='custom-page-css text-xl font-light text-475467'>Tổng xe sở hữu
                <span className='custom-page-css font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary.owned_vehicles.total' })}>{stData.total_info_summary?.owned_vehicles.total}</span>
              </span>

            </div>
            <div className="custom-page-css flex py-2">
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary.owned_vehicles.DL' })}>{stData.total_info_summary?.owned_vehicles.DL}</span>
                <span className='custom-page-css text-xl font-light text-475467'>Xe du lịch</span>
              </div>
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary?.owned_vehicles.TB' })}>{stData.total_info_summary?.owned_vehicles.TB}</span>
                <span className='custom-page-css text-xl font-light text-475467'>Xe tải bus</span>
              </div>
            </div>
          </div>
          <div className="custom-page-css  flex flex-2 flex-column rounded border">
            <div className="custom-page-css w-full flex items-center justify-around gap-4 p-3 border-b">
              <div className="custom-page-css flex items-center justify-center gap-3">
                <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                  <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
                </div>
                <span className='custom-page-css text-xl font-light text-475467'>Tổng chi tiêu
                  <span className='custom-page-css font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary.total_spending.total' })}>{formatNumber(stData.total_info_summary?.total_spending.total)}</span>
                </span>
              </div>
              {/* <span className='custom-page-css text-xl font-light text-475467'>Tổng xe quan tâm
                <span className='custom-page-css font-medium px-1 text-344054'>{stData.total_info_summary.interested_vehicles}</span>
              </span> */}

            </div>
            <div className="custom-page-css flex py-2">
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary.total_spending.vehicle_purchase_invoice' })}>{formatNumber(stData.total_info_summary?.total_spending.vehicle_purchase_invoice)}</span>
                <span className='custom-page-css text-xl font-light text-475467'>Hóa đơn mua xe </span>
              </div>
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary.total_spending.service_invoice' })}>{formatNumber(stData.total_info_summary?.total_spending.service_invoice)}</span>
                <span className='custom-page-css text-xl font-light text-475467'>Hóa đơn dịch vụ </span>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
          <span className='custom-page-css font-regular  text-xl text-1890FF border-b-1890FF'>
            Người liên hệ ({stData.contact_person_total})
          </span>
          <div className='settingCol'>
            <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
              <SettingOutlined />
            </div>
          </div>
        </div>
        <MegaTable
          stData={{ ...megaTableData, listData: stData.contact_person, loading: stData.contact_person_loading }}
          stChange={(data) => {
            setMegaTableData((prev: any) => ({ ...prev, ...data }));
          }}
        />

        <div className={`t-table-block t-table-customer c-table-scoll-x`}>
          <div className="pagination-block">
            <Pagination
              className='rs-pagination'
              showSizeChanger
              total={stData.contact_person_total}
              defaultPageSize={stData.contact_person_params_limit}
              current={stData.contact_person_params_page}
              pageSizeOptions={['10', '20', '50', '100']}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={() => `Tổng cộng ${Math.ceil(stData.contact_person_total / stData.contact_person_params_limit) === 0 ? 1 : Math.ceil(stData.contact_person_total / stData.contact_person_params_page)} trang`}
              locale={{ items_per_page: 'trang' }}
              onChange={(page, pageSize) => {
                stChange({
                  contact_person_params_page: page,
                  contact_person_params_limit: pageSize,
                  contact_person_loading: true,
                })
              }}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}
export default Overview
